/**
 * This file is used to handle the session cookie for the commercetools API
 * Can only be used in the browser
 */

import LocalStorage from "../local-storage";
import {
	isCommercetoolsSession,
	type CommercetoolsSession,
} from "./auth-service";
import { fetchFromCT, type State } from "./fetch-from-ct";

const setSessionCookie = (session: CommercetoolsSession): void => {
	LocalStorage.set("CT_SESSION", JSON.stringify(session));
};

const getSessionCookie = (): CommercetoolsSession | undefined => {
	const sessionString = LocalStorage.get("CT_SESSION");

	let session: CommercetoolsSession | undefined = undefined;

	// Fall back to the old cookie name
	if (sessionString) {
		session = JSON.parse(sessionString) as CommercetoolsSession;
	} else {
		const accessToken = LocalStorage.get("CT_ACCESS_TOKEN");
		const refreshToken = LocalStorage.get("CT_REFRESH_TOKEN");
		if (accessToken && refreshToken) {
			session = {
				accessToken,
				refreshToken,
				expires: Date.now() / 1000 + 1800,
			};
			setSessionCookie(session);
		}
	}

	return isCommercetoolsSession(session) ? session : undefined;
};

export const fetchFromCTWithSession = async <T = unknown>(
	path: string,
	body?: Record<string, unknown>,
	method?: "GET" | "POST" | "DELETE",
): Promise<State<T>> => {
	const session = getSessionCookie();

	const response = await fetchFromCT<T>(path, session, body, method);

	if (response.session) {
		setSessionCookie(response.session);
	}

	return response;
};
